/**
 * @generated SignedSource<<1f603f3fb6902851205ad6023333c22e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type ReorderProjectStagesInput = {
  ids: ReadonlyArray<string>;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type ReorderProjectStagesMutation$variables = {
  input: ReorderProjectStagesInput;
};
export type ReorderProjectStagesMutation$data = {
  readonly reorderProjectStages: {
    readonly company: {
      readonly id: string;
      readonly projectStages: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: string;
            readonly id: string;
            readonly name: string | null;
            readonly sortOrder: number | null;
            readonly profile: PROJECT_STATUS | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type ReorderProjectStagesMutation = {
  variables: ReorderProjectStagesMutation$variables;
  response: ReorderProjectStagesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectStageTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sortOrder",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profile",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReorderProjectStagesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReorderProjectStagesPayload",
        "kind": "LinkedField",
        "name": "reorderProjectStages",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": "projectStages",
                "args": null,
                "concreteType": "ProjectStageTypeConnection",
                "kind": "LinkedField",
                "name": "__Company_projectStages_connection",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReorderProjectStagesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReorderProjectStagesPayload",
        "kind": "LinkedField",
        "name": "reorderProjectStages",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "ProjectStageTypeConnection",
                "kind": "LinkedField",
                "name": "projectStages",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": "projectStages(first:1000)"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Company_projectStages",
                "kind": "LinkedHandle",
                "name": "projectStages"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1799cb2b309e8599e350b7243fcde122",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "reorderProjectStages",
            "company",
            "projectStages"
          ]
        }
      ]
    },
    "name": "ReorderProjectStagesMutation",
    "operationKind": "mutation",
    "text": "mutation ReorderProjectStagesMutation(\n  $input: ReorderProjectStagesInput!\n) {\n  reorderProjectStages(input: $input) {\n    company {\n      id\n      projectStages(first: 1000) {\n        edges {\n          node {\n            __typename\n            id\n            name\n            sortOrder\n            profile\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b0daa5084d4bae9b05bb4157fd5e8f1a";

export default node;
